<script lang="ts" setup>import { shallowRef as _shallowRef } from 'vue';

import ProfileFields from '@consumer/modules/signup/ProfileFields.vue'
import { usersSignup } from '@consumer/api'
import { useUrlSearchParams } from '@vueuse/core'
import type GForm from '@consumer/components/GForm.vue'

withDefaults(defineProps<{
  minimal?: boolean
  email?: string
  name?: string
  confirmWithCode?: boolean
  calendarEventInvitationToken?: string
}>(), {  })

const emit = defineEmits<{ complete: [] }>()

const params = useUrlSearchParams('history')
const form = _shallowRef({
  email: __props.email || (params.email && decodeURIComponent(params.email as string)),
  name: __props.name || undefined,
})

async function onSubmit (user: any) {
  await usersSignup.create({ data: { user: { ...user, confirmWithCode: __props.confirmWithCode, calendarEventInvitationToken: __props.calendarEventInvitationToken } } })
  emit('complete')
}
</script>

<template>
  <GForm :model="form" :onSubmit="onSubmit">
    <GInput
      v-if="minimal"
      v-autofocus
      field="name"
      label="Your Name"
      placeholder="Enter Your Full Name"
      autocapitalize="off"
      autocomplete="off"
      required
    />

    <div v-else class="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-6">
      <ProfileFields/>
      <GInput
        field="email"
        label="Email Address"
        placeholder="Enter Your Email"
        class="w-full"
        autocapitalize="off"
        autocomplete="off"
        required
      />
      <GPasswordInput :minlength="8"/>
    </div>

    <div
      class="flex flex-col gap-6 lg:flex-row justify-between mt-6"
      :class="{'items-start lg:flex-col lg:items-start': minimal, 'items-end': !minimal}"
    >
      <div class="flex flex-col gap-5">
        <GInput
          field="agreeToESignDisclosure"
          type="checkbox"
          name="agree-to-esign-disclosure-checkbox"
          :label="false"
          required="Please agree to the E-Sign Disclosure."
        >
          I agree to the
          <a class="v2link" href="/giftagreement#esign" target="_blank">E-Sign Disclosure</a>
        </GInput>
        <GInput
          field="agreeToTermsAndConditions"
          type="checkbox"
          name="agree-to-terms-and-conditions"
          :label="false"
          required="Please agree to the Terms and Conditions."
        >
          I agree to the
          <a class="v2link" href="/giftagreement" target="_blank">Terms and Conditions</a>
        </GInput>
      </div>
      <div class="w-full" :class="{'lg:w-188px': !minimal}">
        <GRecaptcha>
          <GSaveButton name="create-account-button" label="Create Account" :class="{'w-full' : minimal}"/>
        </GRecaptcha>
      </div>
    </div>
  </GForm>
</template>
